export default "__VITE_ASSET__BC$xFtUt__"